import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from '../../../crystal-elements/cc-base.component';
import {FormFieldConfig} from '../../../model/api/form-field-config';
import {InternalTradeOrderViewService} from '../../../services/internal/internal-trade-order-view.service';
import {CommonFieldService} from '../../../services/common/common-field.service';
import {UserInfoStorageService} from '../../../services/auth/user-info-storage.service';
import {FieldRecord} from '../../../model/api/field-record';

@Component({
  selector: 'app-user-views-dialog',
  templateUrl: './user-view-dialog.component.html',
  styleUrls: ['./user-view-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class UserViewDialogComponent extends CcBaseComponent {

  // fields
  templates: FieldRecord<any>[];

  transPartKey: string = 'user-view';

  @Input()
  dialogFormVisible: boolean = false;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  constructor(cdref: ChangeDetectorRef,
              private internalUserViewService: InternalTradeOrderViewService,
              private commonFieldService: CommonFieldService,
              private userInfoStorageService: UserInfoStorageService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  showDialog(): void {
    this.dialogFormVisible = true;
    this.dialogFormVisibleChange.emit(true);
    this.markForCheck();
  }

  closeDialog(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }

}
